module.exports = __webpack_public_path__ + "img/sort-desc.6a4aee72.svg";